export default __webpack_public_path__ + "static/media/invoice-transmitted.5dbca696.svg";